import { Edition } from '@atlassian/touchpoint-commons-event-analytics/types';

import type { DialogConfig } from '../shared/types';

export const DIALOG_CONFIG: DialogConfig = {
	touchpointIntent: 'addPaymentDetails',
	dialogId: 'premium-add-payment-modal',
	dialogType: 'modal',
	targetProductEdition: Edition.PREMIUM_EDITION,
};
